import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CustomRadioField, CustomSelectField, CustomDateField } from '../../../components';
import formUtils from '../../../utils/formUtils';

function ServiceDetailsSection({ militaryEnums, collected_attributes, intl, yesterdayDate }) {
  return (
    <>
      {collected_attributes.military_current_status && (
        <CustomSelectField
          name="military.current_status"
          id="uu_contact_military_current_status"
          label={<FormattedMessage id="S4lhkg" description="currentStatus" defaultMessage="Current Status" />}
          options={formUtils.translateOptions(intl, militaryEnums.current_status)}
        />
      )}
      {collected_attributes.military_currently_transitioning && (
        <CustomRadioField
          name="military.currently_transitioning"
          label={<FormattedMessage id="mpgPQB" description="currentlyTransitioning" defaultMessage="Currently Transitioning?" />}
          id="uu_contact_military_transitioning"
          options={formUtils.translateOptions(intl, militaryEnums.transitioning)}
        />
      )}
      {collected_attributes.military_at_least_one_day_active_duty && (
        <CustomRadioField
          name="military.at_least_one_day_active_duty"
          label={<FormattedMessage id="OftAFK" description="activeDutyOutsideBasicTraining" defaultMessage="Has at least one day of active duty outside of basic training?" />}
          id="uu_contact_military_at_least_one_day_active_duty"
          options={formUtils.translateOptions(intl, militaryEnums.active_duty)}
        />
      )}
      {collected_attributes.military_branch && (
        <CustomSelectField
          name="military.branch"
          id="uu_contact_military_branch"
          label={<FormattedMessage id="ksVysG" description="branchOfService" defaultMessage="Branch of Service" />}
          options={formUtils.translateOptions(intl, militaryEnums.branch)}
        />
      )}
      {collected_attributes.military_service_era && (
        <CustomSelectField
          name="military.service_era"
          id="uu_contact_military_era"
          label={<FormattedMessage id="QfAiMz" description="serviceEra" defaultMessage="Service Era" />}
          options={formUtils.translateOptions(intl, militaryEnums.service_era)}
        />
      )}
      <div>
        <div className="inline-block w-40 mr-36">
          {collected_attributes.military_entry_date && (
            <CustomDateField
              name="military.entry_date"
              id="uu_military_entry_date"
              label={<FormattedMessage id="Z+MyZ5" description="serviceDates" defaultMessage="Service Dates" />}
              other={{ maxDate: yesterdayDate }}
            />
          )}
        </div>
        <div className="inline-block w-40">
          {collected_attributes.military_exit_date && (
            <CustomDateField
              name="military.exit_date"
              id="uu_military_exit_date"
              other={{ maxDate: yesterdayDate }}
            />
          )}
        </div>
      </div>
    </>
  );
}

ServiceDetailsSection.propTypes = {
  militaryEnums: PropTypes.object.isRequired,
  collected_attributes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  yesterdayDate: PropTypes.instanceOf(Date).isRequired,
};

export default ServiceDetailsSection;
